import { render, staticRenderFns } from "./AuthorizationQr.vue?vue&type=template&id=ef999bc6&scoped=true&lang=pug&"
import script from "./AuthorizationQr.vue?vue&type=script&lang=js&"
export * from "./AuthorizationQr.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationQr.vue?vue&type=style&index=0&id=ef999bc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef999bc6",
  null
  
)

export default component.exports